module.exports = __webpack_public_path__ + "img/T4-B-rc_12.469da979.png";